import { render } from "./DesktopSignature.vue?vue&type=template&id=ad60dbc0"
import script from "./DesktopSignature.vue?vue&type=script&lang=js"
export * from "./DesktopSignature.vue?vue&type=script&lang=js"

import "./DesktopSignature.vue?vue&type=style&index=0&id=ad60dbc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__